import {useBreakpointUp} from '@travel-frontend/core';
import {memo} from 'react';
import {isDesktop} from 'react-device-detect';

import {getForcedTreatmentForTesting} from '@/modules/common/components/ExitIntentLayer/utils';
import {ExitIntentLayerDefault} from '@/modules/common/components/ExitIntentLayerDefault';
import {ExitIntentLayerPicture} from '@/modules/common/components/ExitIntentLayerPicture';
import {useConfig} from '@/modules/common/context/Config';
import {useConsent} from '@/modules/common/context/Consent';
import {useLocalSplit} from '@/modules/common/hooks';
import {useCurrentPage} from '@/modules/common/hooks/useCurrentPage';
import {useHeaderConfig} from '@/modules/common/hooks/useHeaderConfig';

export const ExitIntentLayer = memo(function ExitIntentLayer() {
  const consent = useConsent();
  const config = useConfig();
  const headerConfig = useHeaderConfig();
  const lgUp = useBreakpointUp('lg');
  const currentPage = useCurrentPage();
  const split = useLocalSplit<
    'default' | 'off' | 'on' | 'honeepot' | 'picture'
  >('CAP_280_split_exit_layer');
  const enabled = split.treatment === 'on' || split.treatment === 'picture';
  const consentGiven = consent.status !== null;

  if (!isDesktop || !enabled || !consentGiven) {
    return null;
  }

  const forcedTreatmentForTesting = getForcedTreatmentForTesting();

  if (
    forcedTreatmentForTesting === 'Picture' ||
    (!forcedTreatmentForTesting && split.treatment === 'picture')
  ) {
    return (
      <ExitIntentLayerPicture
        hotline={
          lgUp
            ? (split.config as any)?.[currentPage]?.hotline?.desktop ||
              headerConfig.hotline?.numbers.lg
            : (split.config as any)?.[currentPage]?.hotline?.mobile ||
              headerConfig.hotline?.numbers.sm
        }
        virtualQWidgetUrl={
          lgUp
            ? config.virtualQ.widgetUrlByPage[currentPage]
                .exitIntentLayerPicture?.desktop ||
              config.virtualQ.widgetUrlByPage[currentPage].default.desktop
            : config.virtualQ.widgetUrlByPage[currentPage]
                .exitIntentLayerPicture?.mobile ||
              config.virtualQ.widgetUrlByPage[currentPage].default.mobile
        }
      />
    );
  }

  return (
    <ExitIntentLayerDefault
      config={{
        phoneNumbers: {
          lg:
            (split.config as any)?.[currentPage]?.hotline?.desktop ||
            headerConfig.hotline?.numbers.lg,
          md:
            (split.config as any)?.[currentPage]?.hotline?.mobile ||
            headerConfig.hotline?.numbers.md,
          sm:
            (split.config as any)?.[currentPage]?.hotline?.mobile ||
            headerConfig.hotline?.numbers.sm,
        },
        openingHours: headerConfig?.hotline?.openingHours,
        specials: headerConfig?.hotline?.specials,
      }}
    />
  );
});
